import React from 'react';
import classNames from 'classnames';

interface IPercentageBarProps {
  color?: 'green';
  percentage?: number;
  animate?: boolean;
}

export default function PercentageBar({
  color,
  percentage,
  animate,
}: IPercentageBarProps) {
  const classes = classNames(
    'percentage-bar',
    { 'percentage-bar--green': color === 'green' },
    { 'percentage-bar--animated': animate },
  );

  return (
    <div className={classes}>
      <div
        className="percentage-bar__progress"
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
}
